import { Reducer } from 'redux';
import { Action, ActionType } from '../../actions';
import { FiltersData } from '../../state/TicketTLOV2/FiltersData';

const updateFiltersData: Reducer<FiltersData> = (state: FiltersData = new FiltersData(), action: Action<ActionType, FiltersData>) => {
  switch (action.type) {
    case ActionType.TTLO_V2_FILTERS_UPDATED:
      return { ...state, ...action.data };
    case ActionType.TTLO_V2_FILTERS_RESET:
      return new FiltersData();
    default:
      return state;
  }
};

export default updateFiltersData;
